<template>
        <div class="dropdown float-left">
            <button type="button" :disabled="loading"
                    class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                    id="optionDropDown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                <i v-if="loading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                Sage 300 Options <i class="fa fa-caret-down mx-1"></i>
            </button>
            <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="optionDropDown">
                <button v-if="canErpCreate" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-followup' || company.sage_cre_customer_no" @click.prevent.stop="syncCompany">
                    Connect/Push to Sage 300
                </button>
                <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-followup' || !company.sage_cre_customer_no" @click.prevent.stop="showUpdateCustomerAgaveForm">
                    Update Customer on Sage 300
                </button>
                <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-followup' || !company.sage_cre_customer_no" @click.prevent.stop="openModal('pushOtherContacts')">
                    Push Other Contacts
                </button>
                <button v-if="canErpSync" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-third-party'"  @click.prevent="showSyncFromAgaveForm" >
                    Sync from Sage 300
                </button>
            </div>


        <div class="modal" id="selectCompanyContactsModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Connect/Push</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('selectCompanyContactsModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Select contacts to push to Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li v-for="contact in contacts" class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyContacts" :value="contact" />
                                         <span>{{ contact.name }}</span>
                                       </label>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('selectCompanyContactsModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushCustomerAfterCustomContactCodeCheck" :disabled="!selectedCompanyContacts.length">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="updateCustomerAgave" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Update Customer on Sage 300</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('updateCustomerAgave')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Select the info you want to update on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyUpdateInfo" />
                                         <span>Company Info</span>
                                       </label>
                                    </li>

                                </ul>
                                <p>Synced Contacts</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li v-for="contact in syncedContacts" class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyContacts" :value="contact" />
                                         <span>{{ contact.name }}</span>
                                       </label>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('updateCustomerAgave')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="showUpdateConfirmModal" :disabled="!selectedCompanyUpdateInfo && !selectedCompanyContacts.length">Update</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateCustomerModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of an existing Sage 300 Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{updateCustomerModalBody}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('updateCustomerModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateCustomer()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="pushOtherContacts" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Push Other Contacts</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('pushOtherContacts')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Select the additional contacts you would like to push on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li v-for="contact in contacts" class="form-check">
                                       <label>
                                         <input type="checkbox" :disabled="!!contact.sage_cre_customer_no" v-model="selectedCompanyContacts" :value="contact" />
                                         <span>{{ contact.name }}</span>
                                         <span class="text-green-foundation" v-if="!!contact.sage_cre_customer_no"> Synced with Sage 300</span>
                                       </label>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('pushOtherContacts')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushCustomerAfterCustomContactCodeCheck" :disabled="!selectedCompanyContacts.length">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="getSelectedContactsCustomCode" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sage 300 Custom Contact Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getSelectedContactsCustomCode')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Enter the custom contact numbers to create contacts on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns" style="column-count: 1 ; -moz-column-count : 1">
                                    <li v-for="contact in selectedCompanyContacts" class="form-check">
                                       <label>
                                           <span>"{{ customContactCodeFieldName }}" for contact "<b>{{ contact.name }}</b>"</span>
                                        </label>
                                        <input type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5" v-model="contact.custom_contact_code" :placeholder="customContactCodeFieldName + ' (should be three character code)'" maxlength="3" minlength="3" />
                                    </li>
                                    <br>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getSelectedContactsCustomCode')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushCustomer()" :disabled="selectedCompanyContacts.some(obj => !obj.custom_contact_code || obj.custom_contact_code.length != 3)" title="Contact Code should be 3 characters long">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectCustomerToConnectFollowupModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">This company is not synced with a Sage 300 Customer</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('selectCustomerToConnectFollowupModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Sage 300 customer to sync this company with</label>
                                <div v-if="fetchingCustomers" class="spinner text-sm text-teal">
                                    Fetching customers from Sage 300...
                                </div>
                                <multiselect
                                    v-model="selectedCustomer"
                                    :options="agaveCustomers"
                                    @search-change="searchCustomers"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Searching Sage 300 customer..."
                                    :loading="fetchingCustomers"
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('selectCustomerToConnectFollowupModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedCustomer" @click.prevent="saveSyncedAgaveCustomerContacts">Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="showSyncFromAgave" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sync From Sage 300</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('showSyncFromAgave')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Select what you would like to update on Followup</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyUpdateInfo" />
                                         <span>Company Info</span>
                                       </label>
                                    </li>

                                </ul>
                                <p>Synced Contacts</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li v-for="contact in syncedContacts" class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyContacts" :value="contact" />
                                         <span>{{ contact.name }}</span>
                                       </label>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('showSyncFromAgave')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('showSyncFromAgave');openModal('syncFromAgaveModal')" :disabled="!selectedCompanyUpdateInfo && !selectedCompanyContacts.length">Sync Now</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncFromAgaveModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of an existing Sage 300 Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this company and contact, with info form the synced Sage 300 customer.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('syncFromAgaveModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="saveSyncedAgaveCustomerContacts">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
export default {
    name: 'sage-300-company',
    props: ['mapping','company', 'contacts', 'team','user', 'customCustomerCodeFieldId', 'customContactCodeFieldId', 'customContactCodeFieldName', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    components: {Multiselect},

    data() {
          return {
            loading: false,
            updateCustomerModalBody: '',
            agaveCustomers: [],
            selectedCustomer: null,
            selectedFollowupContact: null,
            fetchingCustomers: false,
            selectedCompanyUpdateInfo: null,
            selectedCompanyContacts : [],
            customCustomerCode: null
        }
    },

    mounted() {
    },
    watch: {
        // 'form.site': function (value) {
        //     this.scrFileStatus();
        // },
    },
    computed: {
        syncedContacts() {
            return this.contacts.filter((c)=> c.sage_cre_customer_no);
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
    },
    methods: {
        showUpdateConfirmModal(){
            let self = this;
            if(self.company.sage_cre_customer_no){
                self.closeModal('updateCustomerAgave');
                self.updateCustomerModalBody = 'This will replace some of the customer info on the Sage 300 Customer record. Are you sure you want to update the customer on Sage 300?';
                self.openModal('updateCustomerModal');
            }
        },
        syncCompany(){
            let self = this;
            if(this.customCustomerCodeFieldId){
                if(this.checkCustomerCustomCode())
                    this.openModal('selectCompanyContactsModal');
            }else{

                let payload = {'company_id': self.company.id, type: 'company'};
                self.loading = true;
                axios.post(route('api.sage300.connect-customer-on-agave'), payload).then((response) => {
                    self.loading = false;

                    if(response.data.status == 'success'){
                        self.company.sage_cre_customer_no = response.data.customer_no
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        this.$parent.fetchContacts();

                    }else{
                        // self.getToast().fire({type: 'error',title: response.data.message});
                        self.openModal('selectCompanyContactsModal');
                    }
                });

            }
        },

        customCustomerCodeChanged(){
            if(this.checkCustomerCustomCode())
                this.openModal('selectCompanyContactsModal');
        },
        checkCustomerCustomCode(){
            if(this.customCustomerCodeFieldId){
                let customerCode = this.getSafe(() => this.$parent.$refs.CompanyCustomFields.form[this.customCustomerCodeFieldId]);
                if(customerCode){
                    if(customerCode.length <= 5){
                        this.customCustomerCode = customerCode;
                        return true;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Invalid Customer Code: must not be greater than 5 characters'
                        });
                        return false;
                    }
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Sage 300 Customer Code is required'
                    });
                    return false;
                }
            }
            return true;
        },

        pushCustomerAfterCustomContactCodeCheck(){
            this.closeModal('pushOtherContacts');
            this.closeModal('selectCompanyContactsModal');

            if(this.customContactCodeFieldId){
                this.openModal('getSelectedContactsCustomCode');
            }else{
                this.pushCustomer();
            }
        },
        pushCustomer(){
            let self = this;
            let payload = {
                'company_id': self.company.id,
                'contact': self.selectedCompanyContacts,
                'customContactCodeFieldId' : this.customContactCodeFieldId,
                'type': 'company',
                'customCustomerCode' : this.customCustomerCode,
                'customCustomerCodeFieldId' : this.customCustomerCodeFieldId
            };
            self.loading = true;
            self.closeModal('pushOtherContacts');
            self.closeModal('selectCompanyContactsModal');
            self.closeModal('getSelectedContactsCustomCode');
            axios.post(route('api.sage300.create-customer-on-agave'), payload).then((response) => {
                self.loading = false;

                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.company.sage_cre_customer_no = response.data.customer_no
                    self.selectedCompanyContacts = [];
                    this.$parent.fetchContacts();
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },

        showUpdateCustomerAgaveForm(){
            this.selectedCompanyContacts = [];
            this.selectedCompanyUpdateInfo = null;
            this.openModal('updateCustomerAgave');
        },

        updateCustomer(){
            let self = this;
            let contact = null;

            if(self.selectedCompanyContacts.length){
                contact = self.selectedCompanyContacts
            }
            let payload = {'company_id': self.company.id, 'contact': contact, update_company_info : self.selectedCompanyUpdateInfo};
            self.loading = true;
            self.closeModal('updateCustomerModal');
            axios.post(route('api.sage300.update-customer-on-agave'), payload).then((response) => {
                self.loading = false;
                self.selectedCompanyContacts = [];
                self.selectedCompanyUpdateInfo = null;

                if(response.data.status == 'success'){
                    self.getToast(3000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.$parent.fetchContacts();

                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },

        showSyncFromAgaveForm(){
            this.selectedCompanyContacts = [];
            this.selectedCompanyUpdateInfo = null;
            if(this.company.sage_cre_customer_no){
                this.openModal('showSyncFromAgave');
            }else{
                this.openModal('selectCustomerToConnectFollowupModal');
            }
        },

        saveSyncedAgaveCustomerContacts(){
            let self = this;
            let payload = {
                connect_with_customer_id: (!this.company.sage_cre_customer_no && this.selectedCustomer) ? this.selectedCustomer : null,
                contactIds: this.getSafe(() => this.selectedCompanyContacts.map(c => c.id)),
                company_id: self.company.id,
                update_company_info: self.selectedCompanyUpdateInfo
            }
            self.loading = true;
            self.closeModal('showSyncFromAgave');
            self.closeModal('syncFromAgaveModal');
            self.closeModal('selectCustomerToConnectFollowupModal');
            axios.post(route('api.sage300.sync-customer-and-contacts-from-agave-to-followup'), payload).then((response) => {
                self.loading = false;
                if(response.data.status == 'success'){
                    //self.company.sage_cre_customer_no = response.data.customer_no
                    //self.company.agave_customer_no = response.data.agave_customer_no
                    self.getToast(3000).fire({type: 'success',title: response.data.message});
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },

        searchCustomers(value) {
            if (value.length >= 3) {
                this.fetchingCustomers = true;
                this.debouncedFilterOptions(value);
            }
        },

        filterOptions(input) {
            let self = this;
            axios.post(route('api.sage300.fetch-customers-from-agave'), {search: input}).then((response) => {
                self.fetchingCustomers = false;
                if(response.data.status == 'success'){
                    self.agaveCustomers = response.data.customers;
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },

        openModal(modalId){
            if(this.contacts.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'No contacts added to this company'
                });

                return false;
            }
            $('#'+modalId).modal('show');
        },

        closeModal( modalId){
            $('#'+modalId).modal('hide');
        },
    }
}
</script>


<style scoped>
    select#teamSelect {
        font-size: 12px !important;
        color: #01b1af !important;
    }
    i.trash-icon-team:hover{
        color: red;
    }
    .text-green-foundation {
        color: #3eb784;
        font-size: 13px;
    }
    .hiddenRow {
        padding: 0 !important;
    }
    #updateCustomerModal .modal-header, #updateCustomerModal .modal-footer{
        background: transparent;
        border-bottom: 0;
        border-top: 0;
    }
    #updateSageCustomerModal .modal-header, #updateSageCustomerModal .modal-footer{
        background: transparent;
        border-bottom: 0;
        border-top: 0;
    }
    .border-radius-25{
        border-radius: 0.25rem;
    }
    .checkboxcolumns {
        column-count: 2;
        column-gap: 2rem;
        list-style: none;
        padding: 0;
    }
</style>
